import React from "react";

const Header = () => {
  return (
    <header>
      <div className="heading"></div>
      <div className="title">
        <h1>Let's Cook</h1>
        <h2>Dine In. Save Money.</h2>
      </div>
    </header>
  );
};

export default Header;
